// extracted by mini-css-extract-plugin
module.exports = {"title":"combo_title__Fn4k9","bannedWarning":"combo_bannedWarning__lzn8u","previewedWarning":"combo_previewedWarning__NlGz5","legalityTable":"combo_legalityTable__okM6w"};